(ns dre.components.privacy.utils
  (:require
   [applied-science.js-interop :as j]
   [dre.config :refer [global-config]] 
   [dre.storage.events :refer [set-ls load-ls]]
   [dre.utils :as utils]
   [re-frame.core :as rf]))

;; TODO change link to actual pdf
(def privacy-pdf-url
  "https://platform.doctorevidence.com/privacy-policy")

(defn accepted-analytics?
  []
  (if (utils/restricted-role? (get global-config :user))
    (= :yes (:accepted? (load-ls :privacy)))
    true))

(def decided-analytics? ;; User made a choice
  (if (utils/restricted-role? (get global-config :user))
    (boolean (:accepted? (load-ls :privacy)))
    true ;; Non-restricted users already accepted the ToS of DRE
    ))

(defn accept-analytics!
  []
  (set-ls :privacy {:accepted? :yes}))

(defn reject-analytics!
  []
  (set-ls :privacy {:accepted? :no}))

(defn load-analytics!
  []
  (when (accepted-analytics?)
    (.log js/console "Loading analytics code")
    (let [user (get global-config :user)
          #_#_segment-writekey (get global-config :segment-writekey)]
      ;; [PLAT-357] Disable heap code
      #_(j/call js/window :loadHeap (clj->js (:raw-response user)))
      #_(j/call js/window :loadAnalytics
                segment-writekey
                (:username user)
                (:email user)
                (:firstname user)
                (:lastname user)
                (:username user)
                (:client user)
                (:roles user)))))
